export default __webpack_public_path__ + "static/media/abhishek-mogaveera.7125ac6a.jpeg";